import React from 'react';
import ContactSection from '../components/ContactSection/ContactSection';

const Contact = () => {
  return (
    <div>
      
      <ContactSection/>
    </div>
  )
};

export default Contact;
